import { createRouter, createWebHistory } from 'vue-router';
import AboutUs from '../features/about-us/AboutUs.vue';
import AboutUsBackground from '../features/about-us/AboutUsBackground.vue';
import Contact from '../features/contact/Contact.vue';
import ChurchServices from '../features/church-services/ChurchServices.vue';
import LoginPage from '../features/auth/LoginPage.vue';
import PreekroosterUpload from '../features/preekrooster/PreekroosterUpload.vue';

export enum ROUTE_NAMES {
  ABOUT_US = 'AboutUs',
  ABOUT_US_BACKGROUND = 'AboutUsBackground',
  HOME_VIEW = 'HomeView',
  EEMDIJK = 'Eemdijk',
  ROOSTER = 'Rooster',
  CONTACT = 'Contact',
  KERKDIENSTEN = 'Kerkdiensten',
  LOGIN = 'Login'
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { top: 0 };
  },
  routes: [
    {
      path: '/',
      name: ROUTE_NAMES.HOME_VIEW,
      component: AboutUs
    },
    {
      path: '/over-ons',
      name: ROUTE_NAMES.ABOUT_US,
      component: AboutUs
    },
    {
      path: '/over-ons/achtergrond',
      name: ROUTE_NAMES.ABOUT_US_BACKGROUND,
      component: AboutUsBackground
    },
    {
      path: '/contact',
      name: ROUTE_NAMES.CONTACT,
      component: Contact
    },
    {
      path: '/kerkdiensten',
      name: ROUTE_NAMES.KERKDIENSTEN,
      component: ChurchServices
    },
    {
      path: '/login',
      name: ROUTE_NAMES.LOGIN,
      component: LoginPage
    },
    {
      path: '/preekrooster',
      name: ROUTE_NAMES.ROOSTER,
      component: PreekroosterUpload
    }
  ]
});
export default router;
